import { DOCUMENT_TYPES } from "@/features/map/utils/index";

/**
 * 親カテゴリ ID に紐づくサブカテゴリ ID の配列を返す。
 * 指定した ID が存在しない場合は空配列を返す。
 *
 * @param parentCategoryId 親カテゴリの ID
 * @returns サブカテゴリ ID の配列
 */
export const getSubCategoryIds = (parentCategoryId: string): string[] => {
  const categoryData = Object.values(DOCUMENT_TYPES)
    .flatMap((section) => section.categories)
    .find((cat) => cat.id === parentCategoryId);

  return categoryData?.subCategories?.map((sub) => sub.id) ?? [];
};

/**
 * ドキュメント ID に紐づく実費（書類取得手数料）を返す。
 * 指定した ID が存在しない場合は 0 を返す。
 *
 * @param docId ドキュメントの ID
 * @returns 費用（円）
 */
export const getCostByDocumentId = (docId: string): number => {
  for (const section of Object.values(DOCUMENT_TYPES)) {
    const category = section.categories.find((cat) => cat.id === docId);
    if (category?.cost !== undefined) {
      return category.cost;
    }

    for (const cat of section.categories) {
      if (cat.subCategories) {
        const subCategory = cat.subCategories.find((sub) => sub.id === docId);
        if (subCategory?.cost !== undefined) {
          return subCategory.cost;
        }
      }
    }
  }

  return 0;
};

/**
 * ドキュメント ID に紐づく表示ラベルを返す。
 * 子カテゴリの場合は "親ラベル - 子ラベル" の形式で返す。
 * 指定した ID が存在しない場合は空文字列を返す。
 *
 * @param docId ドキュメントの ID
 * @returns 表示ラベル文字列
 */
export const getDocumentLabel = (docId: string): string => {
  for (const section of Object.values(DOCUMENT_TYPES)) {
    const category = section.categories.find((cat) => cat.id === docId);
    if (category) {
      return category.label;
    }

    for (const cat of section.categories) {
      if (cat.subCategories) {
        const subCategory = cat.subCategories.find((sub) => sub.id === docId);
        if (subCategory) {
          return `${cat.label} - ${subCategory.label}`;
        }
      }
    }
  }
  return "";
};
